import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _calendarDateTime = { timestamp: 'google.protobuf.Timestamp' };
var _createSessionRequest = { session: '_session' };
var _createSessionResponse = { session: '_session' };
var _deleteSessionRequest = {};
var _deleteSessionResponse = {};
var _getSessionRequest = {};
var _getSessionResponse = { session: '_session' };
var _listSessionsRequest = {};
var _listSessionsResponse = { sessions: '_session' };
var _location = {
    customAddress: '_address',
    businessLocation: '_locationsLocation',
};
var _locationsAddress = { geocode: '_locationsAddressLocation' };
var _locationsAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _locationsLocation = { address: '_locationsAddress' };
var _queryEventSessionInstancesRequest = {
    fromDate: 'google.protobuf.Timestamp',
    toDate: 'google.protobuf.Timestamp',
};
var _queryEventSessionInstancesResponse = { sessions: '_session' };
var _session = {
    originalStart: 'google.protobuf.Timestamp',
    start: '_calendarDateTime',
    end: '_calendarDateTime',
    location: '_location',
};
var _updateSessionRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    session: '_session',
};
var _updateSessionResponse = { session: '_session' };
var _v2QuerySessionsRequest = {
    fromDate: 'google.protobuf.Timestamp',
    toDate: 'google.protobuf.Timestamp',
};
var _v2QuerySessionsResponse = { sessions: '_session' };
function resolveWixBookingsCalendarV2CalendarUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/calendar',
                destPath: '/v2/calendar',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/calendar-2',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v2/calendar',
                destPath: '/v2/calendar',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v2/calendar',
                destPath: '/v2/calendar',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixBookingsCalendarApiV2SessionsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/calendar-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/calendar-server',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/calendar-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/calendar-server',
                destPath: '',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/internal/calendar-server',
                destPath: '/internal',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/_api/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/calendar/listSlots',
                destPath: '/v1/calendar/listSlots',
            },
            {
                srcPath: '/bookings/v1/calendar/listSessions',
                destPath: '/v1/calendar/listSessions',
            },
            {
                srcPath: '/bookings/v2/velo/sessions/query',
                destPath: '/v2/calendar/sessions/query',
            },
            {
                srcPath: '/bookings/v2/calendar/sessions/query',
                destPath: '/v2/calendar/sessions/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixBookingsSchedulesVeloV2VeloSessionsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/schedule-server',
                destPath: '',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
            {
                srcPath: '/internal/schedule-server',
                destPath: '/internal',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/schedule-server',
                destPath: '',
            },
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
            {
                srcPath: '/bookings/v2/velo/sessions',
                destPath: '/v2/velo/sessions',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v1/calendar',
                destPath: '/v1/calendar',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/schedule-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a session.
 *
 * A session is one of the following:
 * + `"EVENT"`: Reserved period of time on any [schedule](wix-bookings-backend.sessions/introduction#schedules). For example, an appointment, class, or course. Events are visible in the Dashboard in the Bookings app's [**Booking Calendar**](https://support.wix.com/en/article/wix-bookings-about-the-wix-bookings-calendar) page. Set `type` to `"EVENT"` when creating sessions that reserve time on a service's schedule, or when creating a blocked time for a resource.
 * + `"WORKING_HOURS"`: Placeholder for available time on a resource’s schedule. Set `type` to `"WORKING_HOURS"` when creating sessions for resource availability.
 *
 * Sessions belong to a schedule. Schedules are owned by a resource or a service.
 *
 * A session may be an individual session or a recurring session.
 * An individual session has a discrete start and end date, while a recurring session defines a series of repeating sessions. An instance of a recurring session is a specific session in a series of repeating sessions, generated according to the recurrence rule.
 * The `start` and `end` properties set the time and duration of the session. For non-recurring sessions, you can use either the `timestamp` or `localDateTime` properties.
 * For recurring sessions, use the `localDateTime` property only. For recurring sessions, the `start` property sets the date and time of the first recurring session, subject to the recurrence rule. For example, if you set the `start` to Saturday, May 1 and your recurrence rule says every second Monday, then the first session will only be on Monday, May 10.
 *
 * The `year`, `monthOfYear` and `dayOfMonth` properties in the `end` property are used with the `hourOfDay` and `minutesOfHour` properties to set the duration of each session relative to the `start`.
 * The `UNTIL` keyword in the `recurrence` property sets the date for the last recurring session.
 *
 * You can create a session that blocks hours on the resource's calendar, making the resource unavailable.
 * Create a non-recurring session of type `"EVENT"`, and add `"Blocked"` to the `tags` array.
 *
 * >**Notes:**
 * > + For properties where there is no explicit time zone information, the time zone used is the business’s time zone.
 * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can create a session. You can override the permissions by setting the `suppressAuth` option to `true`.
 */
export function createSession(payload) {
    var _a = serializer(_createSessionRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSessionResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __createSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'POST',
            methodFqn: 'com.wix.bookings.schedules.velo.v2.VeloSessionsService.CreateSession',
            url: resolveComWixBookingsSchedulesVeloV2VeloSessionsServiceUrl({
                protoPath: '/v2/velo/sessions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSession.fromReq = fromReq;
    __createSession.__isAmbassador = true;
    return __createSession;
}
/**
 * Updates a session.
 *
 * When you update a recurring session, only the future instances of the recurrence will be updated. Changing an individual instance's `start` or `end` time will change the way updates to `start` and `end` on the recurring session affect the session instance:
 * |Change made to the instance | Effect of changes made to the recurrence
 * |--|--|
 * |Instance `start` time changed.|Changes to the recurring session's `start` or `end` time will not update the instance.|
 * |Instance `end` time changed, changing the session's duration| Changes made to the recurring session's start time will be updated on the instance while keeping the new duration, but changes to the recurring session's `end` time not be updated on the instance.
 * |Updating a changed `start` time for an instance back to the recurring session's value.|Future changes to the recurring session `start` and `end` times will update the instance's `starts` and `end` time.
 *
 * Changes to properties on the recurring session, other than `start` and `end`, are always updated on the recurrence instance.
 *
 * Use the `options.participantNotification` object to notify participants if the session has been booked.
 *
 * >**Notes:**
 * > + Where there is no explicit timezone information, the timezone used is the business’s timezone.
 * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can update a session. You can override the permissions by setting the `suppressAuth` option to `true`.
 */
export function updateSession(payload) {
    var _a = serializer(_updateSessionRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSessionResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __updateSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'PATCH',
            methodFqn: 'com.wix.bookings.schedules.velo.v2.VeloSessionsService.UpdateSession',
            url: resolveComWixBookingsSchedulesVeloV2VeloSessionsServiceUrl({
                protoPath: '/v2/velo/sessions/{session.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSession.fromReq = fromReq;
    __updateSession.__isAmbassador = true;
    return __updateSession;
}
/**
 * Deletes a session.
 *
 * Use the `participantNotification` property to send an email to the participants when the session is deleted.
 * When deleting a session of type `"EVENT"` where a booking exists, the booking's status is updated to `"CANCELED"`.
 * To delete a set of recurring sessions, specify the session's `recurringSessionId` in the `sessionId` property in the parameters.
 * When deleting a recurrence, only future instances of the recurrence are deleted.
 *
 * >**Note:** Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can delete a session. You can override the permissions by setting the `suppressAuth` option to `true`.
 */
export function deleteSession(payload) {
    var _a = serializer(_deleteSessionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSessionResponse, {}).fromJSON;
    function __deleteSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'DELETE',
            methodFqn: 'com.wix.bookings.schedules.velo.v2.VeloSessionsService.DeleteSession',
            url: resolveComWixBookingsSchedulesVeloV2VeloSessionsServiceUrl({
                protoPath: '/v2/velo/sessions/{sessionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSession.fromReq = fromReq;
    __deleteSession.__isAmbassador = true;
    return __deleteSession;
}
/**
 * Retrieves a list of sessions, given the provided time range, filtering, and paging.
 *
 * To query for event instances within a specified time range of up to 1 year, provide a `startDate` and `endDate`.
 *
 * Query Sessions runs with these defaults, which you can override:
 * - Only sessions of type `EVENT` are returned. An event is a single or recurring session that appears in a calendar, for example an appointment or a class.
 * - `instances` is true. This means only single session instances and instances of recurring sessions are returned.
 * - `includeExternal` is false. This means that sessions imported from connected external calendars are not returned.
 * - Session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
 * - `query.cursorPaging.limit` is `100`.
 *
 * Note the following limitations, which you can't override:
 * - Sessions are always sorted by `start.timestamp` in `ASC` order.
 * - The maximum time range you can query for session instances is 1 year. If you are querying for recurring session definitions, rather than session instances, this limit doesn't apply.
 * - Pagination is not supported for recurring session definition queries.
 *
 * To query only for working hours sessions, set `type` to `WORKING_HOURS`. A working hours session is a single or recurring session that defines availability in a schedule.
 *
 * To query for all session types, including events and working hours sessions, set `type` to `ALL`.
 *
 * To query for recurring session pattern definitions, set `instances` to `false`. In this case, `fromDate` and `toDate` may be more than 1 year apart.
 *
 * To return session objects including personal information, use the `ALL_PI` fieldset. This requires the Read Bookings Calendar - Including Participants or the Manage Bookings Services and Settings or the Manage Business Calendar [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
 *
 * For details on fieldsets, see [Sessions: Supported Fieldsets](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-fieldsets).
 *
 * For field support for filters, see [Sessions: Supported Filters](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-filters).
 *
 * To learn about working with _Query_ endpoints in general, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function calendarServerQuerySessions(payload) {
    var _a = serializer(_v2QuerySessionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2QuerySessionsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __calendarServerQuerySessions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'POST',
            methodFqn: 'com.wix.bookings.calendar.api.v2.SessionsService.QuerySessions',
            url: resolveComWixBookingsCalendarApiV2SessionsServiceUrl({
                protoPath: '/v2/calendar/sessions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calendarServerQuerySessions.fromReq = fromReq;
    __calendarServerQuerySessions.__isAmbassador = true;
    return __calendarServerQuerySessions;
}
/**
 * Retrieves a session by ID.
 *
 *
 * By default, a session object is returned with the fields specified in the `NO_PI` fieldset. This means it doesn't contain personal information.
 * To retrieve a full session object including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
 */
export function getSession(payload) {
    var _a = serializer(_getSessionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSessionResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __getSession(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'GET',
            methodFqn: 'wix.bookings.calendar.v2.Calendar.GetSession',
            url: resolveWixBookingsCalendarV2CalendarUrl({
                protoPath: '/v2/calendar/sessions/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSession.fromReq = fromReq;
    __getSession.__isAmbassador = true;
    return __getSession;
}
/**
 * Retrieves a list of sessions by their IDs.
 *
 *
 * By default, session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
 * To retrieve full session objects including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
 */
export function listSessions(payload) {
    var _a = serializer(_listSessionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSessionsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __listSessions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'POST',
            methodFqn: 'wix.bookings.calendar.v2.Calendar.ListSessions',
            url: resolveWixBookingsCalendarV2CalendarUrl({
                protoPath: '/v2/calendar/sessions/list',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixBookingsCalendarV2CalendarUrl({
                        protoPath: '/v2/calendar/sessions/list',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __listSessions.fromReq = fromReq;
    __listSessions.__isAmbassador = true;
    return __listSessions;
}
/**
 * Retrieves a list of event session instances, given the provided paging and filtering.
 *
 *
 * By default session objects without any personal information are returned.
 * This means without `participants`, `location`, `calendarConference`, and
 * `externalCalendarOverrides`. You can retrieve full session objects by passing
 * `ALL_PI` in the `fieldsets` array. It isn't possible to retrieve sessions
 * with personal information just for specific participants.
 *
 * > __Note:__ Sessions are sorted by `start.timestamp`, in ascending order.
 * > Other sorting options aren't supported.
 *
 *
 * For a detailed list of supported operations in the Bookings Calendar V2 API, see
 * [filtering](https://dev.wix.com/api/rest/wix-bookings/calendar-v2/filters).
 *
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging).
 */
export function queryEventSessionInstances(payload) {
    var _a = serializer(_queryEventSessionInstancesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventSessionInstancesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _calendarDateTime: _calendarDateTime,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _session: _session,
    }).fromJSON;
    function __queryEventSessionInstances(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.calendar.v1.session',
            method: 'POST',
            methodFqn: 'wix.bookings.calendar.v2.Calendar.QueryEventSessionInstances',
            url: resolveWixBookingsCalendarV2CalendarUrl({
                protoPath: '/v2/calendar/sessions:queryEventInstances',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEventSessionInstances.fromReq = fromReq;
    __queryEventSessionInstances.__isAmbassador = true;
    return __queryEventSessionInstances;
}
//# sourceMappingURL=http.impl.js.map